import React, { useEffect, useRef, useState } from 'react';
import { Card, Icon, SearchBox } from 'tea-component';
import { useIntl } from 'umi';
import { useClickAway } from 'ahooks';

interface ISearchBarProps {
  searchValue?: string;
  onSearch: Function;
  onClear: Function;
  cacheRecentSearch: any[];
  onClickSearchRecent: Function;
  deleteSearchRecent: Function;
  scrollPageCount: number;
  preClassName: string;
}
export default function SearchBar(props: ISearchBarProps) {
  const {
    preClassName,
    searchValue,
    onSearch,
    onClear,
    cacheRecentSearch,
    onClickSearchRecent,
    deleteSearchRecent,
    scrollPageCount,
  } = props;
  const searchRecentProper = useRef<HTMLDivElement>(null);
  /** 搜索关键词 */
  const [search, setSearch] = useState(searchValue);
  const [showSearchRecent, setShowSearchRecent] = useState(false);

  const { formatMessage } = useIntl();

  useClickAway(() => {
    if (showSearchRecent) setShowSearchRecent(false);
  }, searchRecentProper);

  useEffect(() => {
    setShowSearchRecent(false);
  }, [scrollPageCount]);

  useEffect(() => {
    setSearch(searchValue);
  }, [searchValue]);

  return (
    <div className={`${preClassName}-searchbox`} ref={searchRecentProper}>
      <SearchBox
        value={search}
        className="edit-search-box is-search-box"
        onChange={(value) => {
          if (value?.trim() === '') {
            onSearch?.('');
          }
          setSearch(value);
          onClickSearchRecent?.(value);
        }}
        onSearch={(word) => {
          onSearch?.(word?.trim());
          setShowSearchRecent(false);
        }}
        onFocus={() => {
          setShowSearchRecent(true);
        }}
        onClear={() => {
          onClear?.();
        }}
        placeholder={formatMessage({ id: 'dbi_insights_report_search' })}
      />
      {showSearchRecent && (
        <Card className={`${preClassName}-recent-search-card`}>
          <Card.Body>
            <div className={`${preClassName}-recent-search-recent`}>
              {!cacheRecentSearch.length
                ? `${formatMessage({ id: 'dbi_insights_report_search_no_data' })}`
                : `${formatMessage({ id: 'dbi_insights_report_search_recent' })}`}
            </div>
            <div className={`${preClassName}-recent-search-box`}>
              {cacheRecentSearch?.map((item, index) => (
                <div className={`${preClassName}-recent-search-item`} key={index}>
                  <div
                    className="search-text"
                    onClick={() => {
                      setShowSearchRecent(false);
                      onClickSearchRecent?.(item);
                    }}
                  >
                    {item}
                  </div>
                  <Icon
                    type="dismiss"
                    aria-label="dismiss"
                    onClick={(e) => deleteSearchRecent?.(e, index, item)}
                  />
                </div>
              ))}
            </div>
          </Card.Body>
        </Card>
      )}
    </div>
  );
}
